export const handleOnKeyDown = (e) => {
    if (e) {
        e.stopPropagation();
    }
}